module.exports = __webpack_public_path__ + "img/11.9ed2814d.png";